import axiosInstance from '@/utils/api.js'

var state = {
  periodicService: []
}

var getters = {
  PERIODIC_SERVICE: (state) => {
    return state.periodicService
  }
}

var mutations = {
  SET_PERIODIC_SERVICE: (state, payload) => {
    state.periodicService = payload
  }
}

var actions = {
  GET_PERIODIC_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/periodic?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_PERIODIC_SERVICE', result.data)
    }
  },
  CREATE_PERIODIC_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/periodic', payload)
  },
  UPDATE_PERIODIC_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/periodic', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/periodicServices.js